<template>
  <div class="instInputWrap">
    <div class="instInputPosition" v-bind:class="{issetError:fieldStatus.ShowError && fieldStatus.code > 0}">
      <input
        :id="'f'+fieldName"
        v-model="value"
        v-on:blur="eventBlur"
        v-on:focus="eventFocus"
        v-on:keydown="selectSuggestion($event)"
        autocomplete="off"
      >

      <div class="suggestions" v-show="suggestions.length > 0">
        <p
          class="items"
          v-for="(item, index) in suggestions" :key="index"
          v-on:click="onSearchItemSelected(item)"
          v-bind:class="{hover: activeIndex === index}"
        >
          {{ item.value }}
        </p>
      </div>

      <label :for="'f'+fieldName" v-bind:class="{active:value.length > 0 || inFocus}">{{ item.label }}</label>
    </div>
    <p class="instErrMsg" v-if="fieldStatus.ShowError">{{ fieldStatus.msg }}</p>
  </div>
</template>

<script>

import DataForInput from "@/store/Form/longFormOptions";
import {mapGetters, mapState} from "vuex";

export default {
  name: "instInputDadata",
  data: function () {
    return {
      inFocus: false,
      item: DataForInput[this.fieldName],
      suggestions: [],
      activeIndex: 0,
    }
  },
  props: {
    fieldName: {
      type: String,
      default: ''
    },
  },
  methods: {
    eventBlur: function () {
      this.inFocus = false;
      this.$store.dispatch('errorShow', {
        target: this.fieldName,
        value: true,
      });
      //если пользователь кликнул не в подсказки надо прятать подсказки, но если клюкает по подсказкам немного ждем
      setTimeout(() => {
        this.suggestions = []
      }, 300)
    },
    eventFocus: function () {
      this.inFocus = true;
      this.$store.dispatch('errorShow', {
        target: this.fieldName,
        value: false,
      });
    },
    onInputChange(query) {
      if (query.trim().length === 0) {
        return null
      }
      if (this.fieldName === 'PASSPORT_DEP' && this.valueVuex.PASSPORT_DEP_CODE.length > 0) {
        query = this.valueVuex.PASSPORT_DEP_CODE;
      }

      if (this.refs === 'WORK_TITLE') {
        return new Promise(resolve => {
          this.$myApi.suggestResultGigData(query, 5)
            .then(resp => {
              let suggestions = resp.data.suggestions;
              let result = (Array.isArray(suggestions) && suggestions.length) ? suggestions : [];
              resolve(this.suggestions = result);
            })
            .catch(err => {
              console.error("Ошибка при запросе suggestResultGigData", err);
            });
        });
      } else {
        const searchType = this.fieldName === 'WORK_JOB_ADRESS' ? 'REGISTRATION_ADDRESS' : this.fieldName;

        return new Promise(resolve => {
          this.$myApi.suggestResult(
            searchType,
            {'value': query, 'type': searchType}
          ).then(resp => {
            let dadataSuggest = resp.data.result.suggestions;
            let result = (Array.isArray(dadataSuggest) && dadataSuggest.length) ? dadataSuggest : [];
            resolve(this.suggestions = result);
          });
        });
      }
    },
    selectSuggestion(event) {
      switch (event.key) {
        case 'ArrowUp':
          if (this.activeIndex > 0) {
            this.activeIndex -= 1;
          }
          break;
        case 'ArrowDown':
          if (this.activeIndex < (this.suggestions.length - 1)) {
            this.activeIndex += 1;
          }
          break;
        case 'Enter':
          this.onSearchItemSelected(this.suggestions[this.activeIndex]);
          this.inFocus = false;
          break;
        default:
          break
      }
    },
    onSearchItemSelected(item) {
      this.$store.dispatch('saveSendData', {
        target: this.fieldName,
        value: item.value,
        jsonSuggestion: item
      });
      this.namesGenderToStorage(item);
      this.dadataAddressToStorage(item);
      this.suggestions = [];
      this.inFocus = false;
      this.checkAdres();
    },
    namesGenderToStorage(item) {
      if (this.fieldName.indexOf('NAME') > 0) {
        if (item?.data?.gender === 'MALE') {
          this.$store.dispatch('saveSendData', {
            target: 'GENDER',
            value: 'M',
          });
        } else if (item?.data?.gender === 'FEMALE') {
          this.$store.dispatch('saveSendData', {
            target: 'GENDER',
            value: 'F',
          });
        } else {
          return false
        }
      }
    },
    dadataAddressToStorage(item) {
      if (this.fieldName.indexOf('_ADDRESS') > 0 || this.fieldName.indexOf('_JOB') > 0) {
        this.$store.dispatch('saveSendData', {
          target: this.fieldName + '_DADATA',
          value: item,
        });
      }
    },
    checkAdres() {
      // console.log('checkAdres')
      if (this.fieldName === 'RESIDENTIAL_ADDRESS' || this.fieldName === 'REGISTRATION_ADDRESS') {
        const resultCheck = this.isAdressValid(this.fieldName);
        // console.log(resultCheck)
        if (resultCheck.length > 0) {
          this.$store.commit('saveWorkData', {
            target: this.fieldName,
            status: {
              code: 1,
              msg: resultCheck,
              disable: false
            }
          });
          this.$store.commit('saveErrorShow', {
            target: this.fieldName,
            value: true,
          });
        }
      }

    }
  },
  computed: {
    ...mapGetters(['isAdressValid']),
    ...mapState({
      statusVuex: state => state.Form.workData,
      valueVuex: state => state.Form.sendData,
    }),
    fieldStatus() {
      return this.statusVuex[this.fieldName];
    },
    value: {
      get() {
        return this.valueVuex[this.fieldName]
      },
      set(value) {
        // console.log('set')
        this.onInputChange(value);
        this.$store.dispatch('saveSendData', {
          target: this.fieldName,
          value: value
        });
        this.checkAdres();
      }
    },
  }
}
</script>

<style scoped>

</style>